import { useEffect, useState } from 'react';
import { readDraft, writeDraft } from '../utils/formDraft';

// useState dont la valeur est persistée dans localStorage sous `key`.
//
// - restaure la valeur sauvegardée au montage (sinon `initialValue`) ;
// - réécrit à chaque changement de valeur (anti-perte au retour / au reload).
//
// À réserver aux clés STABLES (filtres d'un écran, livreur supervisé…). Pour une
// clé dynamique par entité (ex. une commande), utiliser directement les fonctions
// de utils/formDraft. Pour « remettre à zéro », appeler setValue(initialValue).
export default function usePersistentState(key, initialValue) {
  const storage = typeof window !== 'undefined' ? window.localStorage : null;

  const [value, setValue] = useState(() => {
    const saved = readDraft(storage, key);
    return saved === null || saved === undefined ? initialValue : saved;
  });

  useEffect(() => {
    writeDraft(storage, key, value);
  }, [storage, key, value]);

  return [value, setValue];
}
